<template>
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 44 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    v-bind="$attrs"
  >
    <title>切片</title>
    <g
      id="咨询头部整理优化"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="咨询活动-咨询预沟通"
        transform="translate(-674.000000, -119.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="编组-4" transform="translate(0.000000, 96.000000)">
          <g
            id="按钮/icon按钮/分享按钮/分享黑色44x44"
            transform="translate(674.000000, 23.000000)"
          >
            <path
              d="M22,5.5 C22.8284271,5.5 23.5,6.17157288 23.5,7 C23.5,7.77969612 22.9051119,8.42044868 22.14446,8.49313342 L22,8.5 L9.55091858,8.5 C8.47089583,8.5 7.58402582,9.33623682 7.50563273,10.3938187 L7.5,10.5463412 L7.5,35.1735242 C7.5,36.2483459 8.33754772,37.1357734 9.39441861,37.2142279 L9.54682541,37.2198653 L34.4531746,37.2198653 C35.5320053,37.2198653 36.4162295,36.3823519 36.4943845,35.3175086 L36.5,35.1639075 L36.5,25.2526899 C36.5,24.4242627 37.1715729,23.7526899 38,23.7526899 C38.7796961,23.7526899 39.4204487,24.3475779 39.4931334,25.1082299 L39.5,25.2526899 L39.5,35.1639075 C39.5,37.8822104 37.3593769,40.1003322 34.6722185,40.215193 L34.4531746,40.2198653 L9.54682541,40.2198653 C6.83483489,40.2198653 4.61939102,38.0731678 4.50466682,35.3920513 L4.5,35.1735242 L4.5,10.5463412 C4.5,7.83301565 6.64626519,5.6192956 9.33200539,5.50466305 L9.55091858,5.5 L22,5.5 Z M33.9196517,4.81915703 L39.5674005,10.4669058 C39.9062906,10.8057959 40.051995,11.2639469 40.001873,11.7042585 L40.0050848,11.7342215 C40.045034,12.1649222 39.8983197,12.6095581 39.5674005,12.9404774 L33.9196517,18.5882262 C33.3292897,19.1785881 32.3795651,19.1785653 31.7937786,18.5927789 L31.6901588,18.4781599 C31.2069476,17.8858496 31.2467993,17.0184378 31.7983314,16.4669058 L35.7582493,12.5058176 C29.522838,12.6454183 25.605907,15.2903871 23.3722092,19.6802487 C22.5564965,21.2833599 22.0275603,23.0158807 21.7332944,24.7508332 C21.6302732,25.3582325 21.5642604,25.920414 21.5278547,26.4212484 L21.5025261,26.8746292 L21.5,27 C21.5,27.8284272 20.8284271,28.5 20,28.5 C19.1715729,28.5 18.5,27.8284272 18.5,27 L18.5014885,26.8473873 L18.5140919,26.4965739 C18.5173394,26.4331801 18.521186,26.3673708 18.5256704,26.2992162 L18.5605398,25.8627062 L18.6125712,25.3732801 C18.6533914,25.0301066 18.7068891,24.6539036 18.7755366,24.2491669 C19.1173095,22.2341193 19.7332431,20.2166402 20.698439,18.3197514 C23.2602809,13.2849918 27.751537,10.0653853 34.4254685,9.56760069 L31.7983314,6.94047737 C31.2467993,6.38894533 31.2069476,5.52153354 31.6901588,4.92922323 L31.7937786,4.81460429 C32.3795651,4.22881786 33.3292897,4.22879506 33.9196517,4.81915703 Z"
              id="形状结合"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'svgShareSquare',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}
</script>
